// Module
var code = "<div class=\"card\"> <niveaux-hierarchiques-form ng-if=\"!$ctrl.loading\" trame=\"$ctrl.niveaux\" elements=\"$ctrl.elements\" model=\"$ctrl.values\"> </niveaux-hierarchiques-form> </div> ";
// Exports
module.exports = code;